<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
<div class="general">
    <div class="text-area">
        <i class="fa fa-solid fa-hourglass-end color-icon"></i>
        <h1>PESQUISA EXPIRADA</h1>
        <h2>ESSA PESQUISA ESTÁ EXPIRADA</h2>
    </div>
</div>

